import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function PravnaEtikaIKultura() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Pravna etika i kultura" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Pravna etika i kultura</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Pravna etika i kultura
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Izborni
              </p>
              <p>
                <strong>Broj ECTS:</strong> 4
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>

              <h3>Cilj predmeta</h3>
              <p>
                Cilj nastavnog predmeta Pravna etika i kultura je usvajanje
                osnovnih etičkih znanja potrebnih za razvijanje sposobnosti
                moralnog prosuđivanja i etičkog argumentovanja kao i
                orjentisanja i ponašanja u životu. Shvatanje važnosti uloge
                pravnika – osobe uloge zasnovane na uzajamnom razumijevanju i
                uvažavanju. Nastava će predstavljati kombinaciju predavanja i
                diskusije o problemima. Naročito će se na predavanjima steći
                znanja i voditi rasprave i diskusije o etici i kulturi advokata,
                sudija i tužilaca, pravu koje uređuje advokaturu i pravosudnu
                djelatnost, ulozi advokata, sudija i tužilaca u društvu i
                konceptu postupanja na moralno ispravan način.
              </p>

              <h3>Ishod predmeta</h3>
              <p>
                Očekuje se da student nakon uspješno savladanog gradiva stekne
                znanja i vještine za praktičnu primjenu etičkih standarda u
                bavljenju pravom, odnosno u obavljanju pravničke profesije ili u
                vezi sa njom, i da shvati i razumije osnovne pojmove, pristup i
                komponente pravne i političke kulture.
              </p>

              <h3>Sadržaj predmeta</h3>
              <p>
                Teorijski uvod: Pravo, pravda i moral; Uloga pravnika u praksi
                primjene prava; Normativni izvori etičkih imperativa za sudije,
                advokate i tužioce; Posebna pitanja pravne etike za tužioce;
                Pravni realizam; Položaj pravosuđa i sudska funkcija u procesu
                preobražaja postkomunističkih društava; Sudijski aktivizam;
                Nezavisnost i nepristrasnost sudija; Osnovi za isključenje i
                izuzeće; Sukob interesa i korupcija; Disciplinska i etička
                odgovornost sudija; Nezavisnost sudske vlasti; Položaj prava i
                dužnosti nosilaca pravosudne funkcije (sudija, tužilaca,
                advokata i zaštitnika imovinskopravnih interesa) i sudskog
                osoblja; Nezavisnost, stručnost, savjesnost i brižljivost u
                obavljanju advokatske profesije; Donošenje odluka u odnosu
                advokat–klijent; Dužnost čuvanja advokatske tajne; Etika javnog
                informisanja (posebno u odnosu na izvještavanje o sudskim
                procesima); Poslovi nespojivi sa obavljanjem advokatske
                funkcije; Lojalnost klijenta; Obaveze prema trećim licima;
                Reklamiranje i način privlačenja klijenata; Dužnost čuvanja
                ugleda advokature; Kultura: pojam i određenja; Pravo i politika;
                Politika i kultura; Pravo i kultura; Pojam i elementi pravne
                kulture; Normativna struktura društva: tradicija, moral,
                običaji, ideologija, pravo; Pravne vrijednosti; Značaj pravne
                kulture za funkcionisanje i razvoj pravne države; Ustavno-pravno
                naslijeđe i vladavina prava u Crnoj Gori.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predavanja, vježbe, diskusije, seminarski rad, konsultacije,
                kolokvijumi, završni ispit. Interaktivna nastava koja obuhvata
                uvodno izlaganje od strane predavača i učešće studenta u
                diskusiji; Predavanja i vježbe praćena su odgovarajućim posebno
                izrađenim prezentacijama.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>2P</td>
                    <td>
                      Teorijski uvod: Pravo, pravda i moral; Uloga pravnika u
                      praksi primjene prava; Normativni izvori etičkih
                      imperativa za sudije, advokate i tužioce
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>2P</td>
                    <td>
                      Nezavisnost sudske vlasti; Položaj prava i dužnosti
                      nosilaca pravosudne funkcije (sudija, tužilaca, advokata i
                      zaštitnika imovinskopravnih interesa) i sudskog osoblja
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>2P</td>
                    <td>
                      Pravni realizam; Položaj pravosuđa i sudska funkcija u
                      procesu preobražaja postkomunističkih društava; Sudijski
                      aktivizam
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>2P</td>
                    <td>
                      Nezavisnost i nepristrasnost sudija; Osnovi za isključenje
                      i izuzeće; Sukob interesa i korupcija; Disciplinska i
                      etička odgovornost sudija
                    </td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>2P</td>
                    <td>Posebna pitanja pravne etike za tužioce</td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>2P</td>
                    <td>Kolokvijum I</td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>2P</td>
                    <td>
                      Nezavisnost, stručnost, savjesnost i brižljivost u
                      obavljanju advokatske profesije; Donošenje odluka u odnosu
                      advokat–klijent; Dužnost čuvanja advokatske tajne
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>2P</td>
                    <td>
                      Poslovi nespojivi sa obavljanjem advokatske funkcije;
                      Lojalnost klijenta; Obaveze prema trećim licima;
                      Reklamiranje i način privlačenja klijenata; Dužnost
                      čuvanja ugleda advokature
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>2P</td>
                    <td>
                      Etika javnog informisanja (posebno u odnosu na
                      izvještavanje o sudskim procesima)
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>2P</td>
                    <td>
                      Kultura: pojam i određenja; Pravo i politika; Politika i
                      kultura; Pravo i kultura
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>2P</td>
                    <td>Pojam i elementi pravne kulture</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>2P</td>
                    <td>Kolokvijum II</td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>2P</td>
                    <td>
                      Normativna struktura društva: tradicija, moral, običaji,
                      ideologija, pravo; Pravne vrijednosti
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>2P</td>
                    <td>
                      Značaj pravne kulture za funkcionisanje i razvoj pravne
                      države
                    </td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>2P</td>
                    <td>
                      Ustavno-pravno naslijeđe i vladavina prava u Crnoj Gori
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 2 č / 130h</td>
                            <td>Ukupno: 40 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 2 č / 130h</td>
                            <td>Nastava + završni ispit: 30 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe:</td>
                            <td>Priprema i ovjera semestra: 3 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 7 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default PravnaEtikaIKultura;
